"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.status.pending': '待处理',
    'payment.status.success': '成功',
    'payment.status.rejected': '被拒绝',
    'payment.status.error': '错误',
    'payment.status.unknown': '未知',
};
